export default function React_ForwardRef() {
  return (
    <div>
      <h1>React_ForwardRef Component</h1>
      <p>This is the React_ForwardRef tutorial page.</p>
    </div>
  );
}
